<template>
  <div
    class="t-l_auto iframe-container"
  >
    <iframe
      v-if="canLoad"
      :id="`xx-iframe-${pageKey}`"
      ref="iframe"
      :key="`${pageKey}@${count}`"
      v-bind="attrs"
      class="xx-iframe"
      :src="url"
      :name="targetName"
      owl-ignore
      @load="onLoaded"
      @error="onError"
    ></iframe>
    <!-- 暂时先隐藏这里的插槽，待权限功能改造到现有组件库之后再放开 -->
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "XxContainer",
  inject: ["$$event", "$xxEvent", "$xxRouter"],
  provide() {
    return {
      $xxTabView: this,
    };
  },
  props: {
    pageKey: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      default: "",
    },
    url: {
      type: String,
      required: true,
    },
    targetName: {
      type: String,
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    backColor: {
      type: String,
      default: "#fff",
    },
    active: {
      type: Boolean,
      default: false,
    },
    attrs: {
      type: Object,
      default: () => ({}),
    },
    // 用于消除 iframe url 变化带来的 history 的问题
    count: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      canLoad: false,
      firstLoaded: false,
      /** 专门给平台侧注入变量使用 */
      unload: true, // iframe 组件 load 之前默认是 unload
    };
  },
  watch: {
    active(val) {
      if (val) {
        this.canLoad = true;
      }
    },
    canLoad(val) {
      if (val) {
        this.updateEventTarget();
      }
    },
    count() {
      this.updateEventTarget();
    },
  },
  created() {
    if (this.active) {
      this.canLoad = true;
    }
  },
  beforeUnmount() {
    this.$xxEvent.removeTarget(this.pageKey);
  },
  mounted() {
    this.instance = this.$refs.iframe;
    // iframe 每次 load 之前都会执行 unload
    this.instance.contentWindow.addEventListener('unload', this.handleUnload);
  },
  methods: {
    reload() {
      this.$refs.iframe &&
        this.$refs.iframe.contentWindow &&
        this.$refs.iframe.contentWindow.location.reload();
    },
    onLoaded() {
      if (!this.firstLoaded) {
        this.firstLoaded = true;
      }
      this.updateEventTarget();
      this.$xxRouter.loader.updatePage(this.pageKey, { loading: false });
      // eslint-disable-next-line vue/require-slots-as-functions
      if (this.$slots.default && this.$slots.default.length) {
        // eslint-disable-next-line vue/require-slots-as-functions
        const ref = this.$slots.default[0].componentInstance;
        if (
          ref &&
          ref.getHelperInfo &&
          typeof ref.getHelperInfo === "function"
        ) {
          ref.getHelperInfo();
        }
      }
    },
    onError(...args) {
      this.$$event.$("$app.error", this.pageKey, args);
    },
    updateEventTarget() {
      this.$nextTick(() => {
        if (!this.$refs.iframe) {
          return;
        }
        this.$xxEvent.addTarget(this.$refs.iframe.contentWindow, this.pageKey);
      });
    },
    handleUnload(e) {
      // 调用该 callback 时，如果是 unload，接下来 iframe 将进行 load 事件(此时触发mounted)；而如果 !unload 时，iframe 则真正执行 unload
      if (this.unload) {
        this.unload = false;
        // 加一个使用该框架的标志，由于 unload 在 load 前执行这一事件不一定稳定，故仅在此使用
        this.initAppInfo();
      }
      this.unload = true;
    },
    initAppInfo() {
      if (this.$refs.iframe) {
        this.$refs.iframe.contentWindow.__MICRO_APP_PLATFORM__ = "MALL_VSS";
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.t-l_auto {
  flex: 1;
}

.iframe-container {
  overflow: hidden;
  position: relative;
  height: 100%;
  margin-inline-end: 10px;
}

.xx-iframe {
  position: relative;
  width: 100%;
  height: 100%;
  border: 0;
  // z-index: 1;
  z-index: 3; // .el-tabs__nav 为 2
}

#xx-iframe.full-window,
.xx-iframe.full-window {
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 2000;
  position: fixed !important;
}
</style>
